// extracted by mini-css-extract-plugin
export default {"topShadow":"Stocks_topShadow__dDmhQ","container":"Stocks_container__hld7Q"};